import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Contato from "./pages/Contato";
import Faq from "./pages/Faq";
import NoticiaDetalhe from "./pages/NoticiaDetalhe";
import BoletimDetalhe from "./pages/BoletimDetalhe";
import BuscarCandidatos from "./pages/BuscarCandidatos";
import LayoutDefault from "./layouts/LayoutDefault";
import 'bootstrap-icons/font/bootstrap-icons.css';
const BASE_NAME = process.env.REACT_APP_BASE_NAME;

function App() {
  return (
    <Router basename={BASE_NAME}>
      <Routes>
        <Route
          path="/"
          element={
            <LayoutDefault>
              <Home />
            </LayoutDefault>
          }
        />
        <Route
          path="/contato"
          element={
            <LayoutDefault>
              <Contato />
            </LayoutDefault>
          }
        />
        <Route
          path="/faq"
          element={
            <LayoutDefault>
              <Faq />
            </LayoutDefault>
          }
        />
        <Route
          path="/outra"
          element={
            <LayoutDefault>
              <BuscarCandidatos />
            </LayoutDefault>
          }
        />
        <Route
          path="/noticia/:slug"
          element={
            <LayoutDefault>
              <NoticiaDetalhe />
            </LayoutDefault>
          }
        />
        <Route
          path="/boletim/:slug"
          element={
            <LayoutDefault>
              <BoletimDetalhe />
            </LayoutDefault>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
